/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react';
import { Text, View, StyleSheet, TouchableOpacity, FlatList } from 'react-native';
import { collection, getDocs } from 'firebase/firestore';
import { useIsFocused } from '@react-navigation/native';
import { Activity } from '../types/types';
import db from '../utils/db';

const styles = StyleSheet.create({
  container: {
    marginTop: 0,
    marginLeft: 56,
    marginRight: 56,
    height: 766,
    backgroundColor: '#fff',
    marginBottom: 60,
    width: 1328,
    alignSelf: 'center',
  },
  titleContainer: {
    width: 868,
    marginTop: 47,
    flexDirection: 'row',
    marginHorizontal: 230,
    height: 28,
  },
  title: {
    fontSize: 20,
    color: '#555559',
    fontFamily: 'PingFangSC-Semibold',
  },
  exportButton: {
    height: 28,
    width: 180,
    backgroundColor: '#247a9c',
    marginLeft: 498,
  },
  exportText: {
    height: 22,
    width: 103,
    fontFamily: 'PingFangSC-Semibold',
    fontSize: 16,
    color: '#fff',
    marginLeft: 39,
    marginVertical: 3,
    marginRight: 38,
  },
  headerContainer: {
    flexDirection: 'row',
    height: 49,
    width: 868,
  },
  haederText: {
    fontFamily: 'PingFangSC-Semibold',
    fontSize: 20,
    backgroundColor: '#efefef',
    color: '#979797',
    alignSelf: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    paddingTop: 12,
    paddingBottom: 9,
    height: 49,
  },
  headerDate: {
    width: 129,
    marginRight: 4,
  },
  headerDescription: {
    width: 406,
    marginRight: 4,
  },
  headerAmount: {
    width: 192,
    marginRight: 4,
  },
  headerStatus: {
    width: 129,
  },
  contentContainer: {
    height: 132,
    width: 868,
    flexDirection: 'row',
  },
  contentText: {
    fontFamily: 'PingFangSC-Semibold',
    fontSize: 20,
    color: '#555559',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  contentSmallerText: {
    fontFamily: 'PingFangSC-Semibold',
    fontSize: 15,
    color: '#555559',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  contentDate: {
    textAlign: 'center',
    width: 105,
    marginLeft: 16,
    marginRight: 12,
  },
  contentDescriptionContainer: {
    height: 132,
    width: 406,
  },
  contentDescription: {
    textAlign: 'left',
    marginTop: 24,
    width: 368,
  },
  contentAddress: {
    textAlign: 'left',
    marginBottom: 24,
    width: 368,
  },
  contentAmount: {
    marginLeft: 24,
    width: 165,
    textAlign: 'right',
  },
  contentStatus: {
    marginLeft: 35,
    textAlign: 'center',
    width: 109,
  },
  listContainer: {
    marginTop: 25,
    marginHorizontal: 215,
    height: 580,
  },
});

const ActivityScreen = React.memo(() => {
  const [data, setData] = useState<Activity[]>([]);
  const isFocus = useIsFocused();

  useEffect(() => {
    const fetch = async () => {
      console.log('fetch');
      const newData: Activity[] = [];
      const querySnapshot = await getDocs(collection(db, 'activity'));
      querySnapshot.forEach(doc => {
        console.log(doc.id, ' => ', doc.data());
        // @ts-ignore
        newData.push(doc.data());
      });
      setData(newData);
    };
    if (isFocus) fetch();
  }, [isFocus]);

  const ListHeader = useCallback(() => {
    return (
      <View style={styles.headerContainer}>
        <Text style={[styles.headerDate, styles.haederText]}>Date</Text>
        <Text style={[styles.headerDescription, styles.haederText]}>Description</Text>
        <Text style={[styles.headerAmount, styles.haederText]}>Amount</Text>
        <Text style={[styles.headerStatus, styles.haederText]}>status</Text>
      </View>
    );
  }, []);

  const RenderItem = useCallback(({ item }) => {
    return (
      <View style={styles.contentContainer}>
        <Text style={[styles.contentText, styles.contentDate]}>{item.date}</Text>
        <View style={[styles.contentDescriptionContainer]}>
          <Text style={[styles.contentText, styles.contentDescription]}>{item.description}</Text>
          <Text style={[styles.contentText, styles.contentAddress]}>{item.address}</Text>
        </View>
        <Text
          style={[
            styles.contentText,
            styles.contentAmount,
            { fontSize: item.amount.length < 15 ? 20 : 20 - (item.amount.length - 13) },
          ]}
        >
          {item.amount}
        </Text>
        <Text style={[styles.contentText, styles.contentStatus]}>{item.status}</Text>
      </View>
    );
  }, []);

  return (
    <View style={styles.container}>
      <View style={styles.titleContainer}>
        <Text style={styles.title}>Transaction Activity</Text>
        <TouchableOpacity style={styles.exportButton}>
          <Text style={styles.exportText}>Export to file</Text>
        </TouchableOpacity>
      </View>
      <View style={styles.listContainer}>
        <FlatList
          data={data.sort((a, b) => (a.timestamp > b.timestamp ? -1 : 1))}
          renderItem={RenderItem}
          ListHeaderComponent={ListHeader}
        />
      </View>
    </View>
  );
});

export default ActivityScreen;
